const parseJson = value => {
  if (typeof value !== 'string') return value;
  try { return JSON.parse(value); } catch { return null; }
};

export const normalizeHelcimPaySuccess = eventMessage => {
  const response = parseJson(eventMessage);
  const candidates = [response, parseJson(response?.data)];

  for (const candidate of candidates) {
    if (candidate && typeof candidate === 'object' &&
        typeof candidate.hash === 'string' && candidate.hash.length > 0 &&
        candidate.data && typeof candidate.data === 'object') {
      return { hash: candidate.hash, data: candidate.data };
    }
  }

  return null;
};
